module.exports = __webpack_public_path__ + "static/media/sportssquared-mockup.0be9ef7a.png";